import indexCss from "index.module.css";
import { cn } from "lib/utils";
import { Pages } from "types/common";
import styles from "./page-container.module.css";

const pageHeights: Record<Pages, string> = {
  wealth: styles.wealthHeight,
  retirement: styles.retirementHeight,
  family: styles.familyHeight,
  education: styles.educationHeight,
  mortgage: styles.mortgageHeight,
};

export default function PageContainer({
  page,
  children,
}: {
  page: Pages;
  children: React.ReactNode;
}) {
  const heightClass = pageHeights[page] || styles.defaultHeight;

  return (
    <div className={cn(indexCss.body, styles.container, heightClass)}>
      {children}
    </div>
  );
}
